/**
 * Matches `/deals/<deal_id>/packages/<package_id>` and nested pages
 * (docs, tasks, payments, …) — the `(builder)/packages/[package_id]` segment.
 */
const DEAL_PACKAGE_PATH_RE = /^\/deals\/[^/?#]+\/packages\/[^/?#]+(?:\/|$)/;

export function isDealPackageDocumentPathname(pathname: string): boolean {
  return DEAL_PACKAGE_PATH_RE.test(pathname);
}
